import { createContext, useContext } from 'react';
import { CustomRequestFormType } from './types';

type CustomRequestFormMap = Dictionary<CustomRequestFormType>;

export const CustomRequestFormMapContext = createContext<CustomRequestFormMap>({});

export const useCustomRequestFormMap = () => useContext(CustomRequestFormMapContext);
